import React from 'react';
import { connect } from 'react-redux';
import {
  Checkbox,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
} from '@mui/material';
import { dateTime } from '../../utils/parsing';
import {
  modifyScheduleActionCreator,
  checkScheduleActionCreator,
} from '../../redux/actions/analytics-actions';
import OrganizationsLoader from '../loaders/OrganizationsLoader';
import { SchedulesLoader } from '../loaders/analytics';

const renderInterval = (seconds) => {
  const hours = seconds / 60 / 60;
  if (hours > 48) return `${hours / 24}d`;
  return `${hours}h`;
};

const renderJson = (json) => json && JSON.stringify(json).replace(/:/g, ': ').replace(/,/g, ', ');

const SchedulesTable = ({ schedules, modifySchedule, rerun }) => (
  <div className="qa-schedules">
    <SchedulesLoader />
    <OrganizationsLoader />
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>Id</TableCell>
          <TableCell>Name</TableCell>
          <TableCell>Version</TableCell>
          <TableCell>Enabled?</TableCell>
          <TableCell>Rerun?</TableCell>
          <TableCell>Organization</TableCell>
          <TableCell>First run</TableCell>
          <TableCell>Last run</TableCell>
          <TableCell>Interval</TableCell>
          <TableCell>Executions</TableCell>
          <TableCell>Target</TableCell>
          <TableCell>Data</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {schedules.map((s) => (
          <TableRow key={s.id}>
            <TableCell>{s.id}</TableCell>
            <TableCell>{s.name}</TableCell>
            <TableCell>
              <TextField
                value={s.version}
                type="number"
                onChange={({ target: { value } }) => modifySchedule(s.id, { version: value })}
              />
            </TableCell>
            <TableCell>
              <Checkbox
                checked={s.enabled}
                onChange={({ target: { checked } }) => modifySchedule(s.id, { enabled: checked })}
              />
            </TableCell>
            <TableCell>
              <Button onClick={() => rerun(s.id)} variant="contained">
                Run
              </Button>
            </TableCell>
            <TableCell>{s.target.org_id}</TableCell>
            <TableCell>{dateTime(s.first_run)}</TableCell>
            <TableCell>{dateTime(s.last_run)}</TableCell>
            <TableCell>{renderInterval(s.data_interval)}</TableCell>
            <TableCell>{s.executions.length}</TableCell>
            <TableCell>{JSON.stringify(s.target)}</TableCell>
            <TableCell>{renderJson(s.data)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </div>
);

export default connect(
  ({
    analytics: {
      schedules: { allIds, byId },
    },
  }) => ({
    schedules: allIds.map((id) => byId[id]),
  }),
  (dispatch) => ({
    modifySchedule: (id, changes) => dispatch(modifyScheduleActionCreator(id, changes)),
    rerun: (id) => dispatch(checkScheduleActionCreator(id)),
  })
)(SchedulesTable);
